import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, FormDecidable } from "@/shared/ui";

export interface StepFields {
	hasLessThanOneClosedYear: boolean;
	negativeLastClosedBusinessYear: boolean;
	negativeEquity: boolean;
	hasOverdueNavDebt: boolean;
	hasOverdueLoanDebt: boolean;
}

export class StepA2 extends AbstractStep<StepFields> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDecidable
						label="Céged kevesebb gazdasági múlttal rendelkezik, mint 1 teljes lezárt pénzügyi év?"
						name="hasLessThanOneClosedYear"
						required
					/>
					<FormDecidable
						label="Utolsó lezárt pénzügyi év üzemi/adózott eredménye negatív?"
						name="negativeLastClosedBusinessYear"
						required
					/>
					<FormDecidable
						label="Utolsó lezárt pénzügyi év saját tőkéje negatív?"
						name="negativeEquity"
						required
					/>
					<FormDecidable label="Van lejárt NAV tartozása a cégednek?" name="hasOverdueNavDebt" required />
					<FormDecidable label="Van a cégednek lejárt hiteltartozása?" name="hasOverdueLoanDebt" required />
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "StepA2";
	}
}
